import { getAddress } from 'ethers'
import { useAtom } from 'jotai'
import { useEffect, useRef } from 'react'

import { modal } from '@/contexts'
import { atomLoginStatus, LoginStatus } from '@/stores/login'

export function useAccountEffect(cb: {
  onSuccess: (address: string) => Promise<void>
  onError?: () => void
}) {
  const [loginStatus] = useAtom(atomLoginStatus)

  if (!modal) {
    throw new Error('Please call "createAppKit" first')
  }

  const lastAddress = useRef<string | undefined>(undefined)

  useEffect(() => {
    const fn = () => {
      const rawAddress = modal.getAddress()
      if (!rawAddress) return
      const address = getAddress(rawAddress)
      const refAddress = lastAddress.current
      const cacheAddress = refAddress ?? localStorage.getItem('gata_current_address')

      console.log('[CONNECT_SUCCESS]', { address, cacheAddress, loginStatus })
      if (!address) return

      if (cacheAddress === address && loginStatus === LoginStatus.login) return

      if (refAddress === address) return

      cb?.onSuccess?.(address)
    }
    const unsubscribe = modal?.subscribeEvents((event) => {
      const eventType = event.data.event
      console.log('subscribeEvents', { eventType })
      if (eventType === 'CONNECT_SUCCESS') {
        fn()
      } else if (eventType === 'CONNECT_ERROR') {
        cb?.onError?.()
      }
    })

    modal?.subscribeAccount((account) => {
      const address = localStorage.getItem('gata_current_address')

      if (!account.address || !address) return

      if (account.address === address) return

      if (lastAddress.current !== account.address) {
        console.log('subscribeAccountunit', lastAddress, account.address, address)
        lastAddress.current = account.address
        cb?.onSuccess(account.address)
      }
    })

    return () => {
      unsubscribe?.()
    }
  }, [loginStatus])

  return {}
}
